class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);


/* ===================================================================
   Glow Up – Gratisgeschenke im Warenkorb (Teaser + Popup)
   Liegt bewusst in dieser Datei: der Cart Drawer wird per innerHTML
   eingefuegt, <script>-Tags darin fuehrt der Browser nicht aus.
   =================================================================== */
(function () {
  'use strict';
  if (window.__glowupGiftsLoaded) return;
  window.__glowupGiftsLoaded = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var URLS = { add: ROOT + 'cart/add.js', change: ROOT + 'cart/change.js', update: ROOT + 'cart/update.js' };

  var cleaned = {};    // bereits automatisch entfernte Line-Keys
  var autoTried = {};  // Stufen mit gesetztem Ueberraschungsgeschenk
  var busy = false;
  var modalOpen = false;
  var modalScroll = 0;
  var domWriting = false;   // wir schreiben gerade selbst in den Drawer
  var refreshQueued = false;
  var pendingGift = null;   // waehrend eines Requests angetippte Karte

  var optedOut = {};
  try { optedOut = JSON.parse(sessionStorage.getItem('guOptOut') || '{}'); } catch (e) {}
  function saveOptOut() {
    try { sessionStorage.setItem('guOptOut', JSON.stringify(optedOut)); } catch (e) {}
  }

  /* ---------------- Section-Rendering ---------------- */

  function sectionTargets() {
    var main = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    return [
      { id: 'mini-cart', section: 'mini-cart', selector: '.shopify-section' },
      { id: 'main-cart-items', section: main && main.dataset ? main.dataset.id : null, selector: '.js-contents' },
      { id: 'main-cart-footer', section: footer && footer.dataset ? footer.dataset.id : null, selector: '.js-contents' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
      { id: 'mobile-cart-icon-bubble', section: 'mobile-cart-icon-bubble', selector: '.shopify-section' },
      { id: 'glowup-gifts-cart', section: 'glowup-gifts-cart', selector: '.js-contents' }
    ].filter(function (t) { return t.section && document.getElementById(t.id); });
  }

  function innerHTMLOf(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function renderSections(state) {
    if (!state || !state.sections) return;
    if (modalOpen) {
      var panel = document.querySelector('.gu-modal__panel');
      modalScroll = panel ? panel.scrollTop : 0;
    }
    sectionTargets().forEach(function (t) {
      var host = document.getElementById(t.id);
      var markup = state.sections[t.section];
      if (!host || !markup) return;
      var target = host.querySelector(t.selector) || host;
      var html = innerHTMLOf(markup, t.selector);
      if (html !== null) target.innerHTML = html;
    });
    placeModule();
    portalModal();
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: state } }));
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'glowup-gifts', cart: state });
      }
    } catch (e) { /* optional */ }
  }

  /* ---------------- Cart-Requests ---------------- */

  function post(url, payload, light) {
    if (!light) {
      payload.sections = sectionTargets().map(function (t) { return t.section; }).join(',');
      payload.sections_url = window.location.pathname;
    }
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }

  function removeLine(key, light) { return post(URLS.change, { id: key, quantity: 0 }, light); }

  function addGift(variantId, tier) {
    return post(URLS.add, {
      items: [{ id: Number(variantId), quantity: 1, properties: { _geschenk: String(tier) } }]
    }).then(function (res) {
      if (res && res.sections) return res;
      return fetch(ROOT + 'cart.js').then(function (r) { return r.json(); });
    });
  }

  function setBusy(state) {
    busy = state;
    var root = document.querySelector('gu-gifts');
    if (root) root.classList.toggle('is-busy', state);
    var modal = document.querySelector('.gu-modal');
    if (modal) modal.classList.toggle('is-busy', state);
  }

  /* ---------------- Platzierung ----------------
   * Liquid rendert den Block im Kopfbereich; er gehoert aber direkt ueber den
   * "ZUR KASSE"-Button. Bis er dort steht, ist er per CSS unsichtbar -> kein
   * Springen beim Oeffnen.
   */
  function placeModule() {
    var drawer = document.getElementById('mini-cart');
    var mod = (drawer && drawer.querySelector('gu-gifts')) || document.querySelector('gu-gifts');
    if (!mod) return;

    // Auf der Warenkorbseite steht der Block schon an seinem Platz
    if (!drawer || !drawer.contains(mod)) { mod.classList.add('is-placed'); return; }

    var footer = drawer.querySelector('.mini-cart__footer');
    var checkout = footer && footer.querySelector('.button-container');
    if (!footer || !checkout) return;

    if (mod.parentElement !== footer || mod.nextElementSibling !== checkout) {
      footer.insertBefore(mod, checkout);
    }
    mod.classList.add('is-placed');
  }

  // Sicherheitsnetz: haengt der Block nach 3 s immer noch im Kopfbereich,
  // wird er dort sichtbar gemacht statt unsichtbar zu bleiben.
  setTimeout(function () {
    var stuck = document.querySelector('#mini-cart .mini-cart__header gu-gifts');
    if (stuck) stuck.classList.add('is-fallback');
  }, 3000);

  var placeQueued = false;
  var placeObserver = new MutationObserver(function () {
    if (placeQueued) return;                 // entprellen -> kein Zappeln
    placeQueued = true;
    // bewusst setTimeout statt requestAnimationFrame: rAF pausiert in
    // Hintergrund-Tabs, der Timer laeuft immer
    setTimeout(function () {
      placeQueued = false;
      placeModule();
      portalModal();
      // Das Theme rendert den Drawer auch selbst neu (z. B. "IN DEN WARENKORB"
      // in den Empfehlungen). Dabei gehen unsere Markierungen verloren:
      // Geschenkzeilen bekaemen wieder einen Mengenregler und aufgeteilte
      // Zeilen stuenden doppelt da. Darum nach jedem fremden Render erneut
      // absichern.
      queueRefresh();
    }, 16);
  });
  function watchDrawer() {
    var host = document.getElementById('mini-cart');
    if (host) placeObserver.observe(host, { childList: true, subtree: true });
  }

  /* ---------------- Popup ----------------
   * Das Popup wird an <body> gehaengt, damit es nicht vom Drawer
   * (overflow/transform) abgeschnitten wird.
   */
  function portalModal() {
    var fresh = document.querySelector('gu-gifts .gu-modal');
    if (!fresh) return;
    var old = document.querySelector('body > .gu-modal[data-gu-portal]');
    if (old) old.parentNode.removeChild(old);
    fresh.setAttribute('data-gu-portal', '');
    // Klicks im Popup nicht ans Theme weiterreichen – sonst wertet der
    // Cart Drawer sie als "Klick ausserhalb" und schliesst sich.
    fresh.addEventListener('click', function (e) {
      e.stopPropagation();
      onClick(e);
    });
    fresh.addEventListener('mousedown', function (e) { e.stopPropagation(); });
    fresh.addEventListener('touchstart', function (e) { e.stopPropagation(); }, { passive: true });
    document.body.appendChild(fresh);
    if (modalOpen) {
      fresh.hidden = false;
      var panel = fresh.querySelector('.gu-modal__panel');
      if (panel) panel.scrollTop = modalScroll;
    }
  }

  function openModal(tier) {
    var modal = document.querySelector('.gu-modal');
    if (!modal) return;
    modal.hidden = false;
    modalOpen = true;
    document.documentElement.classList.add('gu-modal-open');
    if (tier) {
      var sec = modal.querySelector('.gu-sec[data-tier="' + tier + '"]');
      if (sec) setTimeout(function () { sec.scrollIntoView({ block: 'start', behavior: 'smooth' }); }, 60);
    }
  }

  function closeModal() {
    var modal = document.querySelector('.gu-modal');
    modalOpen = false;
    modalScroll = 0;
    document.documentElement.classList.remove('gu-modal-open');
    if (modal) modal.hidden = true;
  }

  /* ---------------- Ueberraschungsgeschenk vorauswaehlen ---------------- */
  function autoSelectSurprise() {
    if (busy) return;
    var list = document.querySelectorAll('.gu-modal [data-gu-gift][data-gu-surprise="true"]');
    var target = null;
    for (var i = 0; i < list.length; i++) {
      var b = list[i];
      var tier = b.dataset.tier;
      if (b.disabled) { delete autoTried[tier]; continue; }
      if (parseInt(b.dataset.count || '0', 10) > 0) continue;
      if (autoTried[tier] || optedOut[tier]) continue;
      target = b;
      break;
    }
    if (!target) return;

    autoTried[target.dataset.tier] = true;
    setBusy(true);
    addGift(target.dataset.variant, target.dataset.tier)
      .then(function (state) { renderSections(state); })
      .catch(function (err) { console.error('[glowup-gifts]', err); })
      .finally(function () { setBusy(false); runPending(); autoSelectSurprise(); });
  }

  /* ---------------- Interaktion ----------------
   * Die Auswahl wird sofort angezeigt (optimistisch); der Server bestaetigt
   * sie beim naechsten Render.
   */
  function markOptimistic(btn, wasSelected, replaceKey) {
    var tier = btn.dataset.tier;
    var variant = btn.dataset.variant;
    var single = parseInt(btn.dataset.max || '1', 10) <= 1;
    // jede Karte kommt doppelt vor (Popup + Leiste) -> beide Kopien spiegeln
    var twins = document.querySelectorAll('[data-gu-gift][data-variant="' + variant + '"][data-tier="' + tier + '"]');
    var clear = single
      ? document.querySelectorAll('[data-gu-gift][data-tier="' + tier + '"]')
      : twins;
    // beim Tauschen zusaetzlich das ersetzte Geschenk abwaehlen
    if (!single && replaceKey) {
      var old = document.querySelectorAll('[data-gu-gift][data-line-key="' + replaceKey + '"]');
      var merged = [];
      for (var c = 0; c < clear.length; c++) merged.push(clear[c]);
      for (var o = 0; o < old.length; o++) merged.push(old[o]);
      clear = merged;
    }
    for (var i = 0; i < clear.length; i++) {
      clear[i].classList.remove('is-selected');
      clear[i].dataset.selected = 'false';
      clear[i].setAttribute('aria-pressed', 'false');
    }
    for (var t = 0; t < twins.length; t++) {
      if (!wasSelected) {
        twins[t].classList.add('is-selected');
        twins[t].dataset.selected = 'true';
        twins[t].setAttribute('aria-pressed', 'true');
      }
      twins[t].classList.add('is-loading');
    }
  }

  function onClick(event) {
    var opener = event.target.closest('[data-gu-open]');
    if (opener) {
      event.preventDefault();
      openModal(opener.getAttribute('data-gu-tier'));
      return;
    }
    if (event.target.closest('[data-gu-close]')) {
      event.preventDefault();
      closeModal();
      return;
    }

    var btn = event.target.closest('[data-gu-gift]');
    if (!btn || btn.disabled) return;
    event.preventDefault();

    // Schnelles Mehrfach-Tippen: bisher wurde jeder Tipp waehrend eines
    // laufenden Requests verschluckt - fuer die Kundin sah es aus, als
    // reagiere die Karte nicht. Jetzt wird der letzte Tipp gemerkt, sofort
    // optisch bestaetigt und direkt nach dem laufenden Request ausgefuehrt.
    if (busy) {
      pendingGift = { variant: btn.dataset.variant, tier: btn.dataset.tier };
      markOptimistic(btn, btn.dataset.selected === 'true', '');
      return;
    }

    handleGift(btn);
  }

  function handleGift(btn) {
    var isSelected = btn.dataset.selected === 'true';
    var lineKey = btn.dataset.lineKey || '';   // eigene Warenkorbzeile
    var tierKey = btn.dataset.tierKey || '';   // zuletzt gewaehltes Geschenk der Stufe
    var swapKey = btn.dataset.swapKey || '';   // aeltestes Geschenk der Stufe
    var full = btn.dataset.full === 'true';    // Stufe ausgeschoepft -> tauschen
    // Ist die Stufe voll, ersetzt ein Klick das aelteste Geschenk. Damit laesst
    // sich die Auswahl jederzeit aendern, ohne vorher etwas abwaehlen zu muessen.
    var replaceKey = (!isSelected && full) ? (swapKey || tierKey) : '';

    setBusy(true);
    markOptimistic(btn, isSelected, replaceKey);

    var chain;
    if (isSelected) {
      optedOut[btn.dataset.tier] = 1;
      autoTried[btn.dataset.tier] = true;
      saveOptOut();
      chain = removeLine(lineKey);
    } else if (replaceKey) {
      // altes Geschenk ohne Section-Rendering entfernen -> spart einen
      // kompletten Server-Render pro Klick
      delete optedOut[btn.dataset.tier];
      saveOptOut();
      chain = removeLine(replaceKey, true).then(function () {
        return addGift(btn.dataset.variant, btn.dataset.tier);
      });
    } else {
      delete optedOut[btn.dataset.tier];
      saveOptOut();
      chain = addGift(btn.dataset.variant, btn.dataset.tier);
    }

    chain
      .then(function (state) { renderSections(state); cleanupInvalid(); })
      .catch(function (err) { console.error('[glowup-gifts]', err); })
      .finally(function () { setBusy(false); runPending(); });
  }

  // Holt den gemerkten Tipp auf der frisch gerenderten Karte nach. Gespeichert
  // wird nur der LETZTE Tipp - mehr ist auch nicht gemeint, wenn jemand schnell
  // ueber mehrere Geschenke wischt.
  function runPending() {
    if (!pendingGift || busy) return;
    var want = pendingGift;
    pendingGift = null;
    var sel = '[data-gu-gift][data-variant="' + want.variant + '"][data-tier="' + want.tier + '"]';
    var fresh = document.querySelector('.gu-modal ' + sel) || document.querySelector(sel);
    if (fresh && !fresh.disabled) handleGift(fresh);
  }

  document.addEventListener('click', onClick);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modalOpen) closeModal();
  });

  // Entfernt die Kundin das Geschenk ueber den Papierkorb im Warenkorb, ist das
  // eine bewusste Abwahl - sonst wuerde die Vorauswahl es beim naechsten
  // Seitenaufbau wieder hineinlegen. Der Klick selbst laeuft normal weiter.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('cart-remove-button');
    if (!btn) return;
    var row = btn.closest('[data-gu-tier]');
    if (!row) return;
    var tier = row.getAttribute('data-gu-tier');
    if (!tier) return;
    optedOut[tier] = 1;
    autoTried[tier] = true;
    saveOptOut();
  }, true);

  /* ---------------- Ungueltige Geschenke entfernen ---------------- */
  function cleanupInvalid() {
    var marker = document.querySelector('.gu-invalid');
    if (!marker) return;
    var keys = (marker.dataset.keys || '').split('|').filter(function (k) {
      return k && !cleaned[k];
    });
    if (!keys.length || busy) return;

    keys.forEach(function (k) { cleaned[k] = true; });
    setBusy(true);
    keys.reduce(function (p, key) {
      return p.then(function () { return removeLine(key); });
    }, Promise.resolve())
      .then(function (state) { renderSections(state); cleanupInvalid(); })
      .catch(function (err) { console.error('[glowup-gifts]', err); })
      .finally(function () { setBusy(false); });
  }

  /* ---------------- Geschenkzeilen absichern ----------------
   * Die Geschenke sind echte, regulaer verkaufte Produkte. Es darf also nichts
   * entfernt werden, nur weil so ein Produkt im Warenkorb liegt. Angefasst
   * werden ausschliesslich Zeilen mit der Stufen-Kennzeichnung (_geschenk):
   * dort wird der Mengenregler ausgeblendet und die Gesamtmenge je Stufe auf
   * das erlaubte Maximum begrenzt.
   * Zuordnung Zeile <-> Warenkorbposition ueber data-index des Mengenfeldes.
   */
  function markGiftLines(cart) {
    if (!cart || !cart.items) return;
    cart.items.forEach(function (item, i) {
      var tier = item.properties && item.properties._geschenk;
      rowsByIndex(i + 1).forEach(function (hit) {
        hit.row.classList.toggle('gu-line', !!tier);
        if (tier) hit.row.setAttribute('data-gu-tier', tier);
        else hit.row.removeAttribute('data-gu-tier');
      });
    });
  }

  function tierMax(tier) {
    var el = document.querySelector('[data-gu-gift][data-tier="' + tier + '"]');
    var n = el ? parseInt(el.dataset.max, 10) : 1;
    return n > 0 ? n : 1;
  }

  function guardGiftLines(cart) {
    if (busy || !cart || !cart.items) return false;
    markGiftLines(cart);

    // Wird die Menge eines Geschenks erhoeht, legt Shopify eine zweite Zeile
    // an - eine gratis, eine bezahlt. Es reicht also nicht, die Menge einer
    // einzelnen Zeile zu pruefen; gezaehlt wird die Gesamtmenge aller
    // Geschenkzeilen einer Stufe. Alles ueber dem Limit fliegt raus.
    var byTier = {};
    var tiers = [];
    cart.items.forEach(function (item, i) {
      var tier = item.properties && item.properties._geschenk;
      if (!tier) return;
      if (!byTier[tier]) { byTier[tier] = []; tiers.push(tier); }
      byTier[tier].push({ index: i, quantity: item.quantity });
    });
    if (!tiers.length) return false;

    // Ein einziger, atomarer /cart/update.js-Aufruf ueber Positionsnummern.
    // Mehrere /cart/change.js nacheinander funktionieren hier NICHT: sobald
    // eine Zeile faellt, verteilt Shopify den Rabatt neu und vergibt neue
    // Line-Keys - der zweite Aufruf liefe ins Leere.
    var updates = cart.items.map(function (it) { return it.quantity; });
    var changed = false;
    tiers.forEach(function (tier) {
      var max = tierMax(tier);
      var kept = 0;
      byTier[tier].forEach(function (entry) {
        var room = max - kept;
        if (room < 0) room = 0;
        var want = entry.quantity < room ? entry.quantity : room;
        kept += want;
        if (want !== entry.quantity) {
          updates[entry.index] = want;
          changed = true;
        }
      });
    });
    if (!changed) return false;

    setBusy(true);
    post(URLS.update, { updates: updates })
      .then(function (state) { renderSections(state); })
      .catch(function (err) { console.error('[glowup-gifts]', err); })
      .finally(function () { setBusy(false); });
    return true;
  }

  // Zusatzschutz gegen den kurzen Moment direkt nach einem fremden Render:
  // Mengenregler einer Geschenkzeile wird ignoriert. Das Geschenk waehlt man
  // im Popup ab, nicht ueber den Warenkorb.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('.quantity__button');
    if (!btn) return;
    var row = btn.closest('li, tr');
    if (!row || !row.classList.contains('gu-line')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
  }, true);

  /* ------------- Aufgeteilte Warenkorbzeilen zusammenfassen --------------
   * Shopify teilt eine Warenkorbzeile auf, wenn ein "Kaufe X, erhalte Y"-
   * Rabatt nur einen Teil davon als Bedingung verbraucht (z. B. 3 von 4
   * Cremes). Das Produkt steht dann zweimal im Warenkorb. Serverseitig laesst
   * sich das nicht zusammenfuehren - Shopify teilt sofort wieder auf. Also
   * fassen wir die Zeilen in der Anzeige zusammen und rechnen Mengen-
   * aenderungen auf alle beteiligten Zeilen um.
   */
  function euroText(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function rowsByIndex(idx) {
    var out = [];
    var inputs = document.querySelectorAll('.quantity__input[data-index="' + idx + '"]');
    for (var i = 0; i < inputs.length; i++) {
      var row = inputs[i].closest('li, tr');
      if (row) out.push({ row: row, input: inputs[i] });
    }
    return out;
  }

  // Das Theme haengt Rabatt-Hinweise als eigene <li> hinter die Zeile.
  // Wird eine Zeile ausgeblendet, muessen sie mitverschwinden.
  function hideRow(row) {
    row.classList.add('gu-dupe');
    var next = row.nextElementSibling;
    while (next && next.classList && next.classList.contains('discounts__discount')) {
      next.classList.add('gu-dupe');
      next = next.nextElementSibling;
    }
  }

  function mergeSplitLines(cart) {
    if (!cart || !cart.items) return;
    var map = {}, order = [];
    cart.items.forEach(function (it, i) {
      var key = it.variant_id + '#' + JSON.stringify(it.properties || {});
      if (!map[key]) { map[key] = []; order.push(key); }
      map[key].push({ index: i + 1, qty: it.quantity, price: it.final_line_price });
    });
    order.forEach(function (key) {
      var g = map[key];
      if (g.length < 2) return;
      var total = 0, price = 0, idx = [];
      g.forEach(function (x) { total += x.qty; price += x.price; idx.push(x.index); });

      rowsByIndex(g[0].index).forEach(function (hit) {
        hit.row.setAttribute('data-gu-group', idx.join(','));
        hit.input.value = total;
        hit.input.setAttribute('data-cart-quantity', total);
        var tot = hit.row.querySelector('.cart-item__totals');
        var money = tot && tot.querySelector('price-money, .price');
        if (money) money.textContent = euroText(price);
      });
      for (var j = 1; j < g.length; j++) {
        rowsByIndex(g[j].index).forEach(function (hit) { hideRow(hit.row); });
      }
    });
  }

  function mergedGroupOf(el) {
    var row = el && el.closest ? el.closest('[data-gu-group]') : null;
    if (!row) return null;
    return {
      row: row,
      indices: row.getAttribute('data-gu-group').split(',').map(Number),
      input: row.querySelector('.quantity__input')
    };
  }

  function applyGroupQty(group, newTotal) {
    if (busy) return;
    setBusy(true);
    fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var updates = cart.items.map(function (it, i) {
        return group.indices.indexOf(i + 1) >= 0 ? 0 : it.quantity;
      });
      updates[group.indices[0] - 1] = newTotal > 0 ? newTotal : 0;
      return post(URLS.update, { updates: updates });
    }).then(function (state) { renderSections(state); })
      .catch(function (err) { console.error('[glowup-gifts]', err); })
      .finally(function () { setBusy(false); });
  }

  // Capture-Phase: die Theme-Handler duerfen hier nicht mehr drankommen,
  // sonst wuerde nur eine der beiden Teilzeilen geaendert.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('.quantity__button, cart-remove-button');
    if (!btn) return;
    var g = mergedGroupOf(btn);
    if (!g) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var cur = parseInt(g.input && g.input.value, 10) || 0;
    var next;
    if (btn.tagName === 'CART-REMOVE-BUTTON') next = 0;
    else if (btn.name === 'plus') next = cur + 1;
    else if (btn.name === 'minus') next = cur - 1;
    else return;
    applyGroupQty(g, next);
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var inp = t.closest('.quantity__input');
    if (!inp) return;
    var g = mergedGroupOf(inp);
    if (!g) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    applyGroupQty(g, parseInt(inp.value, 10) || 0);
  }, true);

  /* ------------- Empfehlungen ("PASSEND DAZU") beim Oeffnen zeigen -------
   * Das Theme laedt den Empfehlungs-Block asynchron nach; die Hoehe des
   * Scrollbereichs waechst also erst nach dem Oeffnen. Darum wird der Sprung
   * ans Ende mehrfach wiederholt - und sofort abgebrochen, sobald die
   * Kundin selbst scrollt.
   */
  var revealTimer = null;
  var revealDeadline = 0;   // laeuft weiter, solange sich der Inhalt aendert
  var revealHardStop = 0;   // spaetestes Ende
  var revealLast = -1;      // zuletzt von uns gesetzte Scrollposition
  var revealLastMax = -1;   // zuletzt gesehene Scrollhoehe

  function stopReveal() {
    if (revealTimer) clearTimeout(revealTimer);
    revealTimer = null;
    revealLast = -1;
    revealLastMax = -1;
  }

  function scheduleReveal() {
    if (Date.now() > revealDeadline || Date.now() > revealHardStop) { stopReveal(); return; }
    revealTimer = setTimeout(revealTick, 200);
  }

  // Das Theme laedt die Empfehlungen erst, wenn der Block ins Sichtfeld
  // kommt - im Drawer passiert das nicht zuverlaessig. Darum stossen wir
  // das Laden beim Oeffnen selbst an.
  function primeRecommendations() {
    var rec = document.querySelector('#mini-cart cart-recommendations');
    if (!rec || rec.dataset.guPrimed) return;
    if (typeof rec.handleIntersection !== 'function') return;
    if (rec.querySelector('li, .card, product-card')) return;   // schon gefuellt
    rec.dataset.guPrimed = '1';
    try {
      rec.handleIntersection([{ isIntersecting: true }], { unobserve: function () {} });
    } catch (e) { /* Theme-intern, darf fehlschlagen */ }
  }

  function revealTick() {
    var det = document.querySelector('cart-drawer details');
    if (det && !det.hasAttribute('open')) { stopReveal(); return; }
    primeRecommendations();

    var main = document.querySelector('#mini-cart .mini-cart__main');
    if (!main) { scheduleReveal(); return; }

    var max = main.scrollHeight - main.clientHeight;
    var grew = (max !== revealLastMax);

    // Eigenes Scrollen der Kundin hat Vorrang - aber nur, wenn der Inhalt
    // unveraendert ist (beim Nachladen setzt der Browser scrollTop zurueck).
    if (!grew && revealLast >= 0 && Math.abs(main.scrollTop - revealLast) > 2) {
      stopReveal();
      return;
    }
    if (grew) {
      revealLastMax = max;
      revealDeadline = Date.now() + 2500;   // Inhalt aendert sich noch
    }

    if (max > 4) {
      // Theme setzt scroll-behavior:smooth; die Animation pausiert in
      // Hintergrund-Tabs -> fuer den Sprung kurz auf auto stellen.
      var prev = main.style.scrollBehavior;
      main.style.scrollBehavior = 'auto';
      main.scrollTop = max;
      main.style.scrollBehavior = prev;
      revealLast = main.scrollTop;
    }
    scheduleReveal();
  }

  function startReveal() {
    stopReveal();
    var now = Date.now();
    revealDeadline = now + 3000;
    revealHardStop = now + 9000;
    primeRecommendations();
    revealTimer = setTimeout(revealTick, 150);
  }

  // Entprellt und verhindert eine Endlosschleife: waehrend wir selbst in den
  // Drawer schreiben, loest der MutationObserver keinen neuen Lauf aus.
  function queueRefresh() {
    if (refreshQueued || domWriting || busy) return;
    refreshQueued = true;
    setTimeout(function () { refreshQueued = false; refresh(); }, 60);
  }

  function refresh() {
    cleanupInvalid();
    autoSelectSurprise();
    if (busy) return;
    fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      domWriting = true;
      try {
        if (guardGiftLines(cart)) return;   // Render folgt, danach laeuft refresh erneut
        mergeSplitLines(cart);
      } finally {
        setTimeout(function () { domWriting = false; }, 80);
      }
    }).catch(function (err) { domWriting = false; console.error('[glowup-gifts]', err); });
  }

  // Jedes Oeffnen des Drawers erkennen (auch spaeteres Wiederoeffnen)
  var openObserver = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (t.hasAttribute && t.hasAttribute('open')) {
        startReveal();
        setTimeout(refresh, 120);
        break;
      }
    }
  });
  function watchOpen() {
    var det = document.querySelector('cart-drawer details');
    if (det) openObserver.observe(det, { attributes: true, attributeFilter: ['open'] });
  }

  function init() {
    watchDrawer();
    watchOpen();
    placeModule();
    portalModal();
    setTimeout(refresh, 300);
  }

  document.addEventListener('cart:updated', function () { placeModule(); portalModal(); setTimeout(refresh, 60); });
  document.addEventListener('cartdrawer:opened', function () {
    placeModule(); portalModal(); watchOpen();
    startReveal();
    setTimeout(refresh, 60);
  });
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
